import { apiClient } from '~/api/client';

export type DestroyParams = {
  id: string;
};

export const destroy = async (params: DestroyParams) => apiClient.delete(`/lists/${params.id}`);
